import React from 'react'

interface TabPanelProps {
  selectedTabIndex?: number
  children: React.ReactNode
}

const TabPanel = ({ children }: TabPanelProps) => <>{children}</>

TabPanel.tabType = 'TabPanel'

export default TabPanel
